'use client';
import React, { useEffect } from 'react';

function Footer() {
  function loadBackgroudImages() {
    let backgroudImages = document.querySelectorAll('[data-background]');

    if (backgroudImages.length > 0) {
      backgroudImages.forEach((element) => {
        let image = element.dataset.background;
        element.style.backgroundImage = `url('${image}')`;
      });
    }
  }
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <footer
      className="clean-footer crev bg-img"
      data-background="/light/assets/imgs/header/bg1.jpg"
      data-overlay-dark="10"
    >
      <div className="container pb-40 section-padding ontop">
        <div className="cal-action pb-50 mb-80 bord-thin-bottom">
          <h2 className="fz-120 line-height-1 d-rotate wow">
            <span className="rotate-text">
              <a href="/light/page-contact">
                Get Involved{' '}
                <span className="ml-30 fz-70 ti-arrow-top-right"></span>
              </a>
            </span>
          </h2>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <div className="logo icon-img-100">
              <img src="/light/assets/imgs/spob/logo.png" alt="" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column">
              <div className="mb-40">
                <h6 className="sub-title mb-30">Contact</h6>
                <h5 className="opacity-8">
                  SPOB Nigeria <br /> Lagos, Nigeria
                </h5>
              </div>
              <a href="tel:+2347064659136" className="underline">
                <span className="fz-22 main-color">+234 706 465 9136</span>
              </a>
            </div>
          </div>
          <div className="col-lg-2 offset-lg-1">
            <div className="column">
              <h6 className="sub-title mb-30">Navigate</h6>
              <ul className="rest fz-14">
                <li className="mb-15">
                  <a href="/">Home</a>
                </li>
                <li className="mb-15">
                  <a href="/light/page-about">About Us</a>
                </li>
                <li className="mb-15">
                  <a href="/light/page-services2">Initiatives</a>
                </li>
                <li>
                  <a href="/light/blog-classic">Blog</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column">
              <h6 className="sub-title mb-30">Get Involved</h6>
              <ul className="rest fz-14">
                <li className="mb-15">
                  <a href="/light/page-contact">Volunteer</a>
                </li>
                <li className="mb-15">
                  <a href="/light/page-contact">Donate</a>
                </li>
                <li className="mb-15">
                  <a href="/light/page-contact">Partner With Us</a>
                </li>
                <li>
                  <a href="/light/page-contact">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center pt-30 pb-30 mt-80 bord-thin-top">
          <div>
            <ul className="rest d-flex align-items-center">
              <li className="hover-this cursor-pointer">
                <a href="#0" className="hover-anim">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="hover-this cursor-pointer ml-30">
                <a href="#0" className="hover-anim">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li className="hover-this cursor-pointer ml-30">
                <a href="#0" className="hover-anim">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li className="hover-this cursor-pointer ml-30">
                <a href="#0" className="hover-anim">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="ml-auto">
            <p className="fz-14">
              © 2026 SPOB Nigeria — Strategies for Progress in Opportunity Building. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
